import React from 'react';
import cx from 'classnames';
import type { DatasetInfoPanelProps } from './types';
import styles from './DatasetInfoPanel.module.scss';

export const DatasetInfoPanel = ({
  datasetId,
  createdDate,
  datasetSyncInfo,
  className,
}: DatasetInfoPanelProps) => {
  return (
    <div className={cx(styles.container, className)}>
      <section className={styles.section}>
        <div className={styles.detailRow}>
          <span className={styles.detailKey}>Nexset ID</span>
          <span className={styles.detailValue}>{datasetId}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailKey}>Created On</span>
          <span className={styles.detailValue}>{createdDate}</span>
        </div>
      </section>
      {datasetSyncInfo}
    </div>
  );
};
